export class CurvePointDTO {
latitude: number;
longitude : number;

static mapLonLatCoordinatesToService(coordinates : any) : CurvePointDTO{
  let model = new CurvePointDTO();
  model.latitude = coordinates[0];
  model.longitude = coordinates[1];
  return model;
}
}
